import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    color: "white",
    padding: "26px",
    "@media screen and (max-width: 412px)": {
      paddingLeft: "5px",
      paddingRight: "5px",
    },
  },
  link_2: {
    textDecoration: "none",
  },
  link_button: {
    marginTop: "3rem",
    width: "100%",
    textTransform: "none",
    minWidth: "175px",
    height: "45px",
    fontSize: "18px",
    fontWeight: "bold",
    color: "#00205b",
    backgroundColor: "#ffffff",
    border: "2.5px solid #00205b",
  },
  box_inicio:{
    "@media screen and (max-width: 550px)": {
      width: "90%",
      margin: 'auto'
    },
  },
  logo: {
    width: "100%",
    padding: "3rem 0 1rem 0",
  },
  title: {
    fontWeight: "bold",
    marginBottom: "1rem",
    color: "#00205b",
  },
  sub_title: {
    fontWeight: "bold",
    marginBottom: "1rem",
    color: "#00205b",
    textAlign: "center",
  },
  reset:{
    color: "#00205b",
    fontSize: "16px",
    textDecoration: "underline",
    cursor: "pointer",
    margin: "0.5rem 0"
  },
  select: {
    width: "100%",
    margin: "0.8rem 0 !important",
  },
  labelSelect: {
    color: "#00205b !important",
    fontSize: "16px !important",
    fontWeight: "bold !important",
  },
  box_form: {
    border: "1px solid rgba(128, 128, 128, 0.200)",
    padding: "0 1rem",
    borderRadius: "10px",
    boxShadow: "0 0 5px rgba(0,0,0,.32)",
    marginBottom: "1.5rem",
  },
  type_color: {
    color: "#00205b",
    fontSize: "16px",
    fontWeight: "bold",
  },

  type_color2: {
    color: "#00205b",
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "-15px"
  },

  FechaNacimiento: {
    marginBlockEnd:"-12px",
    color: "#00205b",
    fontSize: "16px",
    fontWeight: "bold",
  },

  info: {
    margin: "1rem 0",
    color: "#00205b",
  },
  select_placeholder: {
    color: "#8080806e",
  },
  MsgError: {
    marginTop: "0px",
    color: theme.palette.error.main,
    fontWeight: "bold",
  },

  helperText: {
    borderRadius: "10px",

    "&  .MuiFormHelperText-root.Mui-error": {
      marginTop: "5px",
      marginLeft: "2px",
     //  color: "#e57373 !important",
      fontFamily: theme.typography.fontFamily,
      fontSize: "16px",
      fontWeight: "bold",
    },
    "&  .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor:"#003876"
    },

    },


  inputText: {
    marginTop: "-1rem",
  },
  buttons_content: {
    "@media screen and (max-width: 470px)": {
      flexDirection: "column",
    },
  },
  button: {
    color: "#ffffff",
    minWidth: "175px",
    height: "45px",
    fontSize: "18px",
    fontWeight: "bold",
    backgroundColor: "#00205b",
    textTransform: "none",
    "@media screen and (max-width: 490px)": {
      width: "100%",
      marginTop: "1rem",
    },
    "&:hover": {
      backgroundColor: "#00207b",
    },
  },
  btn_back: {
    textTransform: "none",
    minWidth: "175px",
    height: "45px",
    fontSize: "18px",
    fontWeight: "bold",
    color: "#00205b",
    backgroundColor: "#ffffff",
    border: "2.5px solid #00205b",
    "@media screen and (max-width: 490px)": {
      width: "100%",
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#FFF",
  },
  redLetter: {
    color: "#fe0000",
    fontWeight: "bold",
    marginBottom: "1rem",
    marginTop: "-1rem",
  },
  imgB:{

    width:"40px",
    "@media screen and (max-width: 360px)":{
      width: '50px'
    }
  },
  wrap:{
    display: 'inline-block',
    color:"#00205b",
    fontWeight: "bold",
    wordWrap: 'break-word',
    wordBreak: 'normal',
    lineBreak: 'strict',
    "@media screen and (max-width: 550px)": {
      maxWidth: '90%',
      margin: '0'
    },
  },
  border_error:{
    border: '1px solid "#fe0000"'
  }, 
  alert_margin:{
    "@media screen and (max-width: 550px)": {
      maxWidth: "90%",
      margin: "auto",
    },
  },
  text_width:{
    "@media screen and (max-width: 550px)": {
      maxWidth: "90%",
    },
    "@media screen and (max-width: 480px)": {
      maxWidth: "70%",
    },
    "@media screen and (max-width: 328x)": {
      maxWidth: "40%",
    }
  },
  borderStyle:{
    border: "1px solid #80808081"
  },
  borderStyle2:{
    border: "1px solid #80808081",
    borderRadius : "5px"
  },

  SelecStyle:{
    border: "2px solid #80808081"

  },
  tarject:{
    textTransform: "uppercase"
  },
  show_hide_box:{
    color:"#00205b",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    
  },
  show_text:{
    textDecoration: "underline"
  },
}));
